import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export const TileSmall = (props) => (
    <SvgIcon {...props}>
        <path d="M3.7,0h-3C0.3,0,0,0.3,0,0.8V6c0,0.5,0.3,0.8,0.8,0.8h3c0.5,0,0.8-0.3,0.8-0.8V0.8C4.5,0.3,4.2,0,3.7,0z" />
        <path d="M3.7,8.2h-3C0.3,8.2,0,8.6,0,9v5.3C0,14.7,0.3,15,0.7,15h3c0.5,0,0.8-0.3,0.8-0.8V9C4.5,8.6,4.2,8.2,3.7,8.2z" />
        <path d="M9.7,0h-3C6.3,0,6,0.3,6,0.8V6c0,0.5,0.3,0.8,0.8,0.8h3c0.5,0,0.8-0.3,0.8-0.8V0.8C10.5,0.3,10.2,0,9.7,0z" />
        <path d="M9.7,8.2h-3C6.3,8.2,6,8.6,6,9v5.3C6,14.7,6.3,15,6.7,15h3c0.5,0,0.8-0.3,0.8-0.8V9C10.5,8.6,10.2,8.2,9.7,8.2z" />
        <path d="M15.7,0h-3C12.3,0,12,0.3,12,0.8V6c0,0.5,0.3,0.8,0.8,0.8h3c0.5,0,0.8-0.3,0.8-0.8V0.8C16.5,0.3,16.2,0,15.7,0z" />
        <path d="M15.7,8.2h-3C12.3,8.2,12,8.6,12,9v5.3c0,0.5,0.3,0.8,0.8,0.8h3c0.5,0,0.8-0.3,0.8-0.8V9C16.5,8.6,16.2,8.2,15.7,8.2z" />
        <path d="M3.8,16.5h-3c-0.5,0-0.8,0.3-0.8,0.8v5.3c0,0.5,0.3,0.8,0.8,0.8h3c0.5,0,0.8-0.3,0.8-0.8v-5.3C4.6,16.8,4.3,16.5,3.8,16.5z" />
        <path d="M9.8,16.5h-3c-0.5,0-0.8,0.3-0.8,0.8v5.3c0,0.5,0.3,0.8,0.8,0.8h3c0.5,0,0.8-0.3,0.8-0.8v-5.3C10.6,16.8,10.3,16.5,9.8,16.5z" />
        <path d="M15.8,16.5h-3c-0.5,0-0.8,0.3-0.8,0.8v5.3c0,0.5,0.3,0.8,0.8,0.8h3c0.5,0,0.8-0.3,0.8-0.8v-5.3C16.6,16.8,16.3,16.5,15.8,16.5z" />
    </SvgIcon>
);

export default TileSmall;
